import React from 'react';
import { Link } from 'react-router';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const MatchingComplete = () => (
  <div className='completion-block'>
    <h2>Success!</h2>
    <p>Your data is now being matched.
      Check the <Link to='/jobs'>Status</Link> page for progress updates</p>
    <LinkContainer to='/' >
      <Button block bsStyle='primary' bsSize='large'>Go to Overview Page</Button>
    </LinkContainer>
  </div>
);

export default MatchingComplete;
